/**
* Determines the visibility state of the mobile navigation insert based on feature flags.
*
* @param {object} params - Parameters object.
* @param {boolean} params.subnavEnabled - Whether the sub-navigation is enabled.
* @param {boolean} params.eventDayRecircEnabled - Whether event day recirculation is enabled.
* @param {boolean} params.tocEnabled - Whether the table of contents is enabled.
* @returns {string} The visibility state: 'disabled', 'collapseOnScroll', or 'visible'.
*/
export const getMobileNavInsertVisibility = ({
  subnavEnabled,
  eventDayRecircEnabled,
  tocEnabled,
}) => {
  if (eventDayRecircEnabled) {
    if (tocEnabled || subnavEnabled) {
      return 'disabled';
    }

    return 'collapseOnScroll';
  }

  return 'visible';
};
